import { useState } from 'react'

import { cn } from '@/shared/lib'
import { Icon, TextButton } from '@/shared/ui'

type UseExpandProps = {
  defaultExpanded?: boolean
}

export const useExpand = ({ defaultExpanded = false }: UseExpandProps = {}) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  const toggleExpand = () => {
    setExpanded(prevExpanded => !prevExpanded)
  }

  return { expanded, toggleExpand }
}

type ButtonProps = {
  expanded: boolean
  onClick: () => void
}

export const ExpandButton = ({ expanded, onClick }: ButtonProps) => {
  return (
    <TextButton onClick={onClick} color="gray" size="large" className="gap-0">
      {expanded ? '접기' : '더보기'}
      <Icon
        name="arrow-bottom"
        size={16}
        className={cn(
          'gap-0 transition-transform duration-300',
          expanded && 'rotate-180',
        )}
      />
    </TextButton>
  )
}
